export enum ReportType {
  'REBOOKING_INITIATE_REPORT',
  'REBOOKING_APPROVAL_REPORT',
}
